module.exports = __webpack_public_path__ + "static/media/number-of-units.dcf0cd60.svg";